import { Permission } from "src/app/views/wrapper/payroll/company/setting/settings";

export const URL_PERMISSION = [
  {
    url: '/payroll/employee',
    permission: Permission.AccessEmployee,
    menu: 'employee',
  }, {
    url: '/payroll',
    permission: Permission.AccessPayroll,
    menu: 'payroll',
  }, {
    url: '/payroll/notification',
    permission: Permission.AccessNotification,
    menu: 'notification',
  }, {
    url: '/payroll/attendance',
    permission: Permission.AccessAttendance,
    menu: 'attendance',
  }, {
    url: '/payroll/job',
    permission: Permission.AccessJob,
    menu: 'job',
  }, {
    url: '/payroll/company',
    permission: Permission.AccessSetting,
    menu: 'settings',
  }, {
    url: '/payroll/employee/add',
    permission: Permission.AddEmployee,
    menu: 'employee',
  }, {
    url: '/payroll/employee/edit',
    permission: Permission.EditEmployee,
    menu: 'employee',
  }, {
    url: '/payroll/employee/about',
    permission: Permission.EditEmployee,
    menu: 'employee',
  }, {
    url: '/payroll/employee/contact',
    permission: Permission.EditEmployee,
    menu: 'employee',
  }, {
    url: '/payroll/employee/employment',
    permission: Permission.EditEmployee,
    menu: 'employee',
  }, {
    url: '/payroll/employee/organization',
    permission: Permission.EditEmployee,
    menu: 'employee',
  }, {
    url: '/payroll/employee/absence',
    permission: Permission.EditEmployeeLeave,
    menu: 'employee',
  }, {
    url: '/payroll/employee/edit-absence',
    permission: Permission.EditEmployeeLeave,
    menu: 'employee',
  }, {
    url: '/payroll/employee/compensation',
    permission: Permission.ViewEmployeeSalary,
    menu: 'employee',
  }
]
